'use client';

import { PublicKey } from '@solana/web3.js';
import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityAccountsStore from 'src/stores/useVelocityAccountsStore';

/**
 * Hook for updating the current subaccount, including both store state and velocity client.
 */
export const useUpdateCurrentSubaccount = () => {
	const velocityClient = useVelocityStore((s) => s.velocityClient.client);
	const updateCurrentSubAccount = useVelocityAccountsStore(
		(s) => s._updateCurrentSubAccount
	);

	const updateCurrentSubaccount = useCallback(
		(newSubaccountId: number, authority: PublicKey) => {
			// Update the store state
			updateCurrentSubAccount(newSubaccountId, authority);

			// Switch the active user in the velocity client
			velocityClient?.switchActiveUser(newSubaccountId, authority);
		},
		[velocityClient, updateCurrentSubAccount]
	);

	return { updateCurrentSubaccount };
};
